var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellentHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_6034)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 88.8418C74.3675 88.8418 92.5 70.7093 92.5 48.3418C92.5 25.9743 74.3675 7.8418 52 7.8418C29.6325 7.8418 11.5 25.9743 11.5 48.3418C11.5 70.7093 29.6325 88.8418 52 88.8418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 84.3418C71.8822 84.3418 88 68.2241 88 48.3418C88 28.4595 71.8822 12.3418 52 12.3418C32.1177 12.3418 16 28.4595 16 48.3418C16 68.2241 32.1177 84.3418 52 84.3418Z",
    fill: "url(#paint0_linear_502_6034)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8714 55.3398C31.8714 55.3398 50.4689 52.2775 72.6515 55.3398C72.6515 55.3398 73.3237 73.4891 52.2614 73.4891C31.1992 73.4891 31.8714 55.3398 31.8714 55.3398Z",
    fill: "#5B0600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_6034",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 53,
    width: 42,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8714 55.3398C31.8714 55.3398 50.4689 52.2775 72.6515 55.3398C72.6515 55.3398 73.3237 73.4891 52.2614 73.4891C31.1992 73.4891 31.8714 55.3398 31.8714 55.3398Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_6034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2614 82.4518C61.8313 82.4518 69.5892 78.4391 69.5892 73.4891C69.5892 68.5392 61.8313 64.5265 52.2614 64.5265C42.6915 64.5265 34.9336 68.5392 34.9336 73.4891C34.9336 78.4391 42.6915 82.4518 52.2614 82.4518Z",
    fill: "#8E1112"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7137 30.7673C37.6971 31.2901 36.2033 33.0827 35.9792 34.9499C34.8589 33.4561 32.6929 32.5598 30.6763 33.0827C28.1369 33.7549 26.6431 36.1449 27.3153 38.759C28.2116 42.2694 32.7676 44.1366 39.2655 48.0204C43.1493 41.4478 46.2116 37.7134 45.3153 34.203C44.7178 31.5142 42.2531 30.0951 39.7137 30.7673Z",
    fill: "url(#paint1_linear_502_6034)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.361 30.7673C61.8216 30.0951 59.3569 31.5142 58.6847 34.1283C57.7884 37.6387 60.8506 41.4478 64.7344 47.9457C71.3071 44.0619 75.7884 42.1947 76.6847 38.6843C77.3569 36.0702 75.8631 33.6802 73.3237 33.008C71.3071 32.4851 69.1411 33.3067 68.0208 34.8752C67.8714 33.0826 66.3776 31.2901 64.361 30.7673Z",
    fill: "url(#paint2_linear_502_6034)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_6034",
    x: -3.8,
    y: -3.8582,
    width: 111.6,
    height: 111.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_6034"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_6034",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_6034",
    x1: 20.8351,
    y1: 66.3225,
    x2: 83.2299,
    y2: 30.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198685,
    stopColor: "#FFBA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    stopColor: "#FFCE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_6034",
    x1: 28.2314,
    y1: 42.2615,
    x2: 46.2918,
    y2: 37.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00411293,
    stopColor: "#D2254D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D65C4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_6034",
    x1: 75.8801,
    y1: 42.2614,
    x2: 57.8199,
    y2: 37.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00411293,
    stopColor: "#D2254D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D65C4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellentHover);
export default __webpack_public_path__ + "static/media/excellent-hover.20d7442646cfbf4917f140a8e9d14f89.svg";
export { ForwardRef as ReactComponent };